/**
 * 公用常量
*/

//路由元数据
export const ROUTER_DATA = 'app/ROUTER_DATA';

//加载层状态
export const LOADING_STATE = 'app/LOADING_STATE';

//用户信息
export const USER_INFO_DATA = 'app/USER_INFO_DATA';

//用户菜单权限信息等
export const USER_ROUTE_DATA = 'app/USER_ROUTE_DATA';
